import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddressGuard implements CanActivate {
  constructor(private router: Router, private toastr: ToastrService,private translate:TranslateService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let address = localStorage.getItem('address');
    let lng = localStorage.getItem('lng');
    let lat = localStorage.getItem('lat');
    if (address && lng && lat) return true;
    this.toastr.warning(this.translate.instant('Please select your address'));
    this.router.navigate(['/']);
    return false;
  }
}
